import MedicationDeliveryInfo from './MedicationDeliveryInfo';

export default MedicationDeliveryInfo;
